<template>
  <div class="error-page">
    <div class="error-code">4<span>0</span>4</div>
    <div class="error-desc">{{ $t('notFind.pageNotFound') }}</div>
    <br/>
    <div class="error-handle">
      <router-link to="/workbench/dashboard">
        <el-button size="large" type="primary">{{ $t('notFind.backToHome') }}</el-button>
      </router-link>
      <el-button class="error-btn" size="large" type="primary" @click="goBack">{{
          $t('notFind.backToPrevious')
        }}
      </el-button>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: '404',
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.error-page {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  background: #f3f3f3;
  box-sizing: border-box;
}

.error-code {
  line-height: 1;
  font-size: 250px;
  font-weight: bolder;
  color: #2d8cf0;
}

.error-code span {
  color: #00a854;
}

.error-desc {
  font-size: 30px;
  color: #777;
  margin-top: 30px;
}

.error-handle {
  margin: 30px;
}

.error-btn {
  margin-left: 100px;
}
</style>
